import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  SubscriptionBannerUpgradeComponent
} from '@components/subscription-banner/subscription-banner-upgrade/subscription-banner-upgrade.component';
import { DialogData } from '@client/shared/components/document/upload-document-dialog/upload-document-dialog.component';
import {
  SubscriptionChangeDialogComponent
} from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';

@Component({
  selector: 'app-subscription-banner-upgrade-work',
  templateUrl: './subscription-banner-upgrade-work.component.html',
  styleUrls: ['./subscription-banner-upgrade-work.component.scss'],
  standalone: false
})
export class SubscriptionBannerUpgradeWorkComponent {
  constructor(
    private dialogRef: MatDialogRef<SubscriptionBannerUpgradeComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  openSubscriptionDialog(): void {
    this.dialog.open(SubscriptionChangeDialogComponent, {
      panelClass: 'dialog-extra-large',
    });

    this.dialogRef.close();
  }
}
